// Specify the current URL in entry.xxxx. Thereby letting user pre-populate one answer.
export const FORM_URL_BASE =
  'https://docs.google.com/forms/d/e/1FAIpQLSe8E2GmFpN-fQD8NnZoxPAOpqSpahA4Qr6l-TYSvZPAosmSYw/viewform?usp=pp_url&entry.1037755123=';
